export enum EIndustry {
  CHEMICAL = 'Chemical',
  FASHION = 'Fashion',
  FMCG = 'FMCG',
  HIGH_TECH = 'High Tech',
  INDUSTRIALS = 'Industrials',
  OIL_AND_GAS = 'Oil & Gas',
  PHARMA = 'Pharma',
  PULP_AND_PAPER = 'Pulp & Paper',
  RETAIL = 'Retail',
  SMCG = 'SMCG',
}
